var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-contract-table',{attrs:{"title":_vm.$t('global.models.contract.heading'),"subtitle":_vm.$t('global.models.contract.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }